function AlarmInfo() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Report.AlarmInfo Visual. <br/>
    /// basically just calls the get data from the visual and sets the clocktimer
    /// USES the load type 2 for the the Unit.Overview Widget = Load Alarms
    /// <br/>
    /// Author: MWI<br />
    /// Date: 20.01.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 20.01.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>  
};
AlarmInfo.prototype = new vcTemplate();

AlarmInfo.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// by getting the data from the  Unit.Overview Widget and loading the clocktimer
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
       
        me.showInfo("", "", false);
        window.VisualCoreService.getDataByName("VISUAL_UNIT_SYSTEMOVERVIEW", '1', getCurrentTimestamp(), me.visual.width(), me.visual.height(), "", "", 1, JSON.stringify({ "type": 2, "bsaid": me.bsaid, "alarmid": me.alarmid, "loggerid": me.loggerid }), function (result) {

            me.visual.html(result);
            me.visual.find(".clock").vcClockTimer({ width: "500px" });
            me.visual.find('.cl').off('click');
        });

        return true;
    } catch (ex) {
        me.writeError("AlarmInfo.init", ex);
        return false;
    }
};

//#END REGION FILTER